<template lang="pug">
.v-text-guide.text-guide(v-if="data" :id="data?.id")
	template(v-for="item in data.items" )
		h3.h3(v-if="item.title") {{ item.title }}
		p(v-if="item.text" v-html="item.text")
		ul(v-if="item.items && item.items.length")
			li(v-for="element in item.items" v-html="element")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		content: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			data: null,
		}
	},

	watch: {
		content(state) {
			this.data = state;
		}
	},

	mounted() {
		if (this.content) {
			this.data = this.content;
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},
	}
}

</script>